import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap, shareReplay } from "rxjs/operators";

@Injectable()
export class ConstantsService {
  constantsCache: Observable<any>;
  constructor(private http: HttpClientService) {}

  public getByName(name: string): Observable<any> {
    let options = {
      params: { name: name },
    };
    return this.http
      .get("/api/constants/name", options)
      .pipe(tap((_) => console.log("ConstantsService.getByName: Ok.")));
  }

  public getConstants(): Observable<any> {
    if (!this.constantsCache) {
      this.constantsCache = this.requestConstants().pipe(shareReplay(1));
    }
    return this.constantsCache;
  }

  private requestConstants(): Observable<any> {
    return this.http.get("/api/constants").pipe(tap((_) => console.log("ConstantsService.getConstants: Ok")));
  }
}
